module.exports = __webpack_public_path__ + "stopwatch.png?051cef60bb9b8afdd72b6d83f6c4a70c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stopwatch.png
// module id = 41
// module chunks = 0